import React, { useEffect, useRef, useState } from "react";
import Header from "../Header";
import {
  handleGetApiGF,
  isWebView,
  shareIphonePostMsg,
  Toast,
  Userlogin,
} from "../Utils/general-function";
import { useNavigate } from "react-router-dom";
import Loader from "../Utils/Loader";
import html2pdf from "html2pdf.js";
import html2canvas from "html2canvas";

function Challan(props) {
  const [loading, setLoading] = useState(false);
  const [carNumber, setCarNumber] = useState("");
  const ChallanRef = useRef();
  const [totalChallan, setTotalChallan] = useState(null);
  const [challanData, setChallanData] = useState([]);
  const [err, setErr] = useState("");
  const navigate = useNavigate();

  const OnChange = (e) => {
    setCarNumber(e.target.value.toUpperCase());
    setChallanData([]);
  };
  useEffect(() => {
    if (!Userlogin()) {
      navigate("/Login");
      return;
    }
  }, []);
  const validateVehicleNumber = (value) => {
    const number = value.toUpperCase().replace(/[\s-]/g, "");
    const normalVehicleRegex = /^[A-Z]{2}[0-9]{1,4}[A-Z]{1,3}[0-9]{4}$/;

    const bhVehicleRegex = /^[0-9]{2}BH[0-9]{4}[A-Z]{2}$/;

    return normalVehicleRegex.test(number) || bhVehicleRegex.test(number);
  };
  const onSubmit = async () => {
    // const div = document.getElementById("result");
    // const btndiv = document.getElementById("btndiv");
    // div.style.display = "block";
    // btndiv.style.display = "flex";
    if (!validateVehicleNumber(carNumber)) {
      setErr("Please enter a valid vehicle registration number.");
      return;
    } else {
      setErr("");
    }
    setLoading(true);

    try {
      const res = await handleGetApiGF({
        url: "/api/challanAPI/VehicalChallanAPI?Carno=" + carNumber,
      });

      setLoading(false);

      if (!res?.succ) {
        Toast(false, res?.msg, res?.msg);
        return;
      }
      let parsedData = res?.data?.Data ? JSON.parse(res?.data?.Data) : {};
      let data = parsedData?.data?.challan_details;

      if (data.length < 1) {
        Toast(false, "", parsedData?.message);
      }
      let totalChallan = data?.reduce(
        (acc, data, i) => acc + parseFloat(data?.amount) || 0,
        0,
      );
      setTotalChallan(totalChallan);
      setChallanData(data);
    } catch (error) {
      setLoading(false);
    }
  };

  const download = async () => {
    setLoading(true);
    let filename = carNumber + ".pdf";

    // const div = document.getElementById("result");
    const div = ChallanRef.current;
    console.log("div", div);

    const options = {
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
      margin: [2, 2, 5, 5],
      filename: carNumber + ".pdf",
      image: {
        type: "jpeg",
        quality: 1.0,
      },
      html2canvas: {
        scale: 2,
        dpi: 192,
        letterRendering: true,
        allowTaint: true,
      },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "portrait",
        compress: true,
      },
    };
    if (isWebView()) {
      let bs64 = await html2pdf()
        .from(div)
        .set(options)
        .toPdf()
        .output("datauristring");
      await shareIphonePostMsg({ data: bs64, filename, action: "sharebase64" });
      setLoading(false);
      return;
    }
    await html2pdf().from(div).set(options).toPdf().get("pdf").save();
    setLoading(false);
  };

  const rupeeFormat = (rs) =>
    rs.toLocaleString("en-IN", {
      maximumFractionDigits: 0,
      style: "currency",
      currency: "INR",
    });

  useEffect(() => {
    if (
      !validateVehicleNumber(carNumber) &&
      String(carNumber).trim().length > 0
    ) {
      setErr("Please enter a valid vehicle registration number.");
      return;
    } else {
      setErr("");
    }
  }, [carNumber]);
  return (
    <div>
      <Header />
      {loading ? <Loader /> : null}
      <div className="text-center">
        <h2 className="page-title">Check Vehicle Challan</h2>
      </div>
      <div className="page-space">
        <div className="input-group mt-2">
          <input
            type="text"
            className="form-control"
            placeholder="RC Number"
            name="carNumber"
            value={carNumber}
            maxLength={10}
            onChange={OnChange}
          />
          <button
            className="btn rc-submit"
            type="submit"
            onClick={(e) => onSubmit()}
          >
            Submit
          </button>
        </div>
        <p className="text-danger">{err}</p>
        {challanData.length > 0 && (
          <>
            <div
              className="justify-content-center mb-2"
              id="btndiv"
              style={{ display: "flex" }}
            >
              <button
                className="btn rc-submit mt-3"
                style={{ lineHeight: "18px" }}
                type="submit"
                onClick={(e) => download()}
              >
                Download Pdf
              </button>
              {/* <button className="cardoc-btn">
            <img
              src="assets/images/share-d.png"
              alt="share"
              style={{ width: "32px" }}
              onClick={(e) => share()}
            />
          </button> */}
            </div>
            <div id="result" style={{ display: "block" }} ref={ChallanRef}>
              <div className="pt-2">
                <div className="d-flex text-center flex-column">
                  <span>
                    <img
                      src="assets/images/logo.png"
                      style={{ maxWidth: "120px" }}
                      alt=""
                    />
                  </span>
                  <h4 className="ch-carno">{carNumber}</h4>
                </div>
              </div>
              {challanData.map((data, i) => (
                <div className="challan-div" key={data?.challanNumber}>
                  <span style={{ fontSize: "16px" }}>
                    Challan No-{data?.challan_number}
                  </span>
                  <div className="ch-details">
                    <div>
                      <span>Name- </span>
                      {data?.accused_name}
                    </div>
                    <div>
                      <span>Challan Place</span> - {data?.challan_place}
                    </div>
                    <div>
                      <span>RTO</span> - {data?.rto}
                    </div>
                    <div>
                      <span>State</span> - {data?.state}
                    </div>
                    <div>
                      <span>Challan Date</span> -{" "}
                      {new Date(data?.challan_date).toLocaleDateString("es-CL")}
                      {" : "}
                      {data?.challan_date_time?.split("T")?.[1]}
                    </div>
                    <div>
                      <span>Amount</span> -{" "}
                      {rupeeFormat(parseFloat(data?.amount) || 0)}
                    </div>
                    <div>
                      <span>Challan Status</span> - {data?.challan_status}
                    </div>

                    <div>
                      <span>Offense Detail</span> - {data?.offense_details}
                    </div>
                    <div>
                      <span>Court Challan</span> -{" "}
                      {data?.court_challan === true ? "Yes" : "No"}
                    </div>

                    {/* <div>
                  <span>Receipt No </span> -{" "}
                </div>
                <div>
                  <span>Payment Mode </span> -{" "}
                </div>
                <div>
                  <span>Payment Date </span> -{" "}
                </div> */}
                  </div>

                  {challanData.length === i + 1 && (
                    <h1 className="mt-3 text-center text-danger">
                      Total Challan :{" "}
                      {rupeeFormat(parseFloat(totalChallan) || 0)}
                    </h1>
                  )}
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default Challan;

// import React, { useEffect, useRef, useState } from "react";
// import Header from "../Header";
// import { handleGetApiGF, Toast, Userlogin } from "../Utils/general-function";
// import { useNavigate } from "react-router-dom";
// import Loader from "../Utils/Loader";
// import html2pdf from "html2pdf.js";
// import html2canvas from "html2canvas";

// //   forChallan: null,
// //   typeAccused: null,
// //   nameViolator: "NAKUM NAGJIBHAI GOPALBHAI",
// //   violatorFatherName: "GOPALBHAI",
// //   violatorContactNo: "6351235570",
// //   dlRcNumber: "GJ03NF8988",
// //   challanNo: "GJ218442250525182015",
// //   State: "GJ",
// //   dateChallan: "2025-05-25 00:00:00",
// //   detailsViolation: [
// //     {
// //       offence: "Having dark film on glass/કાચ ઉપર ડાર્ક ફિલ્મ ( 177 ) ",
// //       penalty: null,
// //     },
// //   ],
// //   investigateUnder: null,
// //   longLat: null,
// //   locationChallan:
// //     "8R47+93W, Ranchod Nagar Society, Arya Nagar, Rajkot, Gujarat 360003, India",
// //   remarkChallan: null,
// //   typeBook: null,
// //   bookNo: null,
// //   formNo: null,
// //   witness1: null,
// //   witness2: null,
// //   witness3: null,
// //   imagesChallan: null,
// //   imageVehicle: "",
// //   imageCCTV1: null,
// //   imageCCTV2: null,
// //   numberDL: null,
// //   detailsDL: null,
// //   suspendISDL: null,
// //   accNameDL: null,
// //   accAddressDL: null,
// //   accFatherNameDL: null,
// //   accAgeDL: null,
// //   accGenderDL: null,
// //   validityDL: null,
// //   issueDateDL: null,
// //   issuedByDL: null,
// //   amountChallan: 1000,
// //   status: "Unpaid",
// //   sourcePayment: null,
// //   datePayment: null,
// //   IDTransaction: null,
// //   noReceipt: null,
// //   noReceiptOffline: null,
// //   receiptOffline: null,
// //   noMobile: null,
// //   byPayment: null,
// //   acfIS: null,
// //   amountACF: null,
// //   noReceiptACF: null,
// //   nameRTO: "Rajkot City",
// //   impoundDocument: null,
// //   impoundVehicle: null,
// //   classVehicle: null,
// //   typeVehicle: null,
// //   uptoVehicle: null,
// //   uptoPermit: null,
// //   rcNo: "GJ03NF8988",
// //   noChassis: null,
// //   noEngine: null,
// //   noVehOwner: null,
// //   nameOwner: null,
// //   nameFatherOwner: null,
// //   addressOwner: null,
// //   idCourt: null,
// //   statusCourt: null,
// //   idCourtRelated: null,
// //   imgOrderRelease: null,
// //   dateRelease: null,
// //   noReceiptCourt: null,
// //   byAction: null,
// //   noDispatch: null,
// //   nameCourt: null,
// //   chargesUser: null,
// //   challan_search_source: "ECHALLAN",
// //   court_status_desc: "PHYSICAL COURT",
// // },
// function Challan(props) {
//   const [loading, setLoading] = useState(false);
//   const [carNumber, setCarNumber] = useState("");
//   const ChallanRef = useRef();
//   const [totalChallan, setTotalChallan] = useState(null);
//   const [challanData, setChallanData] = useState([]);

//   const navigate = useNavigate();

//   const OnChange = (e) => {
//     setCarNumber(e.target.value.toUpperCase());
//     setChallanData([]);
//   };
//   useEffect(() => {
//     if (!Userlogin()) {
//       navigate("/Login");
//       return;
//     }
//   }, []);

//   const onSubmit = async () => {
//     setLoading(true);
//     // const div = document.getElementById("result");
//     // const btndiv = document.getElementById("btndiv");

//     // div.style.display = "block";
//     // btndiv.style.display = "flex";

//     try {
//       const res = await handleGetApiGF({
//         url: "/api/challanAPI/VehicalChallanAPI?Carno=" + carNumber,
//       });
//       console.log("res", res);
//       setLoading(false);

//       if (!res?.succ) {
//         Toast(false, res?.msg, res?.msg);
//         return;
//       }
//       let data = res?.data?.Data
//         ? JSON.parse(res?.data?.Data)?.data.challan_details
//         : [];
//       let totalChallan = data?.reduce(
//         (acc, data, i) => acc + data?.amount || 0,
//         0,
//       );
//       setTotalChallan(totalChallan);
//       setChallanData(data);
//     } catch (error) {
//       setLoading(false);
//     }
//   };

//   const download = async () => {
//     setLoading(true);
//     // const div = document.getElementById("result");
//     const div = ChallanRef.current;
//     console.log("div", div);

//     const options = {
//       pagebreak: { mode: ["avoid-all", "css", "legacy"] },
//       margin: [2, 2, 5, 5],
//       filename: carNumber + ".pdf",
//       image: {
//         type: "jpeg",
//         quality: 1.0,
//       },
//       html2canvas: {
//         scale: 2,
//         dpi: 192,
//         letterRendering: true,
//         allowTaint: true,
//       },
//       jsPDF: {
//         unit: "mm",
//         format: "a4",
//         orientation: "portrait",
//         compress: true,
//       },
//     };

//     await html2pdf().from(div).set(options).toPdf().get("pdf").save();
//     setLoading(false);
//   };

//   const rupeeFormat = (rs) =>
//     rs.toLocaleString("en-IN", {
//       maximumFractionDigits: 0,
//       style: "currency",
//       currency: "INR",
//     });
//   return (
//     <div>
//       <Header />
//       {loading ? <Loader /> : null}
//       <div className="text-center">
//         <h2 className="page-title">Check Vehicle Challan</h2>
//       </div>
//       <div className="page-space">
//         <div className="input-group mt-2">
//           <input
//             type="text"
//             className="form-control"
//             placeholder="RC Number"
//             name="carNumber"
//             value={carNumber}
//             onChange={OnChange}
//           />
//           <button
//             className="btn rc-submit"
//             type="submit"
//             onClick={(e) => onSubmit()}
//           >
//             Submit
//           </button>
//         </div>
//         {challanData.length >= 0 && (
//           <>
//             <div
//               className="justify-content-center mb-2"
//               id="btndiv"
//               style={{ display: "flex" }}
//             >
//               <button
//                 className="btn rc-submit mt-3"
//                 style={{ lineHeight: "18px" }}
//                 type="submit"
//                 onClick={(e) => download()}
//               >
//                 Download Pdf
//               </button>
//               {/* <button className="cardoc-btn">
//             <img
//               src="assets/images/share-d.png"
//               alt="share"
//               style={{ width: "32px" }}
//               onClick={(e) => share()}
//             />
//           </button> */}
//             </div>
//             <div id="result" style={{ display: "block" }} ref={ChallanRef}>
//               <div className="pt-2">
//                 <div className="d-flex text-center flex-column">
//                   <span>
//                     <img
//                       src="assets/images/logo.png"
//                       style={{ maxWidth: "120px" }}
//                       alt=""
//                     />
//                   </span>
//                   <h4 className="ch-carno">{carNumber}</h4>
//                 </div>
//               </div>
//               {challanData.map((data, i) => (
//                 <div className="challan-div" key={data?.challanNumber}>
//                   <span>Challan No-{data?.challan_number}</span>
//                   <div className="ch-details">
//                     <div>
//                       <span>Name- </span>
//                       {data?.accused_name}
//                     </div>
//                     <div>
//                       <span>Challan Place</span> - {data?.challan_place}
//                     </div>
//                     <div>
//                       <span>RTO</span> - {data?.rto}
//                     </div>
//                     <div>
//                       <span>State</span> - {data?.state}
//                     </div>
//                     <div>
//                       <span>Challan Date</span> -{" "}
//                       {new Date(data?.challan_date).toLocaleDateString("es-CL")}
//                       {" : "}
//                       {data?.challan_date_time?.split("T")?.[1]}
//                     </div>
//                     <div>
//                       <span>Amount</span> -{" "}
//                       {rupeeFormat(parseFloat(data?.amount) || 0)}
//                     </div>
//                     <div>
//                       <span>Challan Status</span> - {data?.challan_status}
//                     </div>

//                     <div>
//                       <span>Offense Detail</span> - {data?.offense_details}
//                     </div>
//                     <div>
//                       <span>Court Challan</span> -{" "}
//                       {data?.court_challan === true ? "Yes" : "No"}
//                     </div>

//                     {/* <div>
//                   <span>Receipt No </span> -{" "}
//                 </div>
//                 <div>
//                   <span>Payment Mode </span> -{" "}
//                 </div>
//                 <div>
//                   <span>Payment Date </span> -{" "}
//                 </div> */}
//                   </div>

//                   {challanData.length === i + 1 && (
//                     <h1 className="mt-3 text-center text-danger">
//                       Total Challan :{" "}
//                       {rupeeFormat(parseFloat(totalChallan) || 0)}
//                     </h1>
//                   )}
//                 </div>
//               ))}
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// }

// export default Challan;
